import { SpinnerService } from './../../../services/shared/spinner.service';
import { Specifications } from 'src/app/models/product-settings-model';
import { LocalStorageService } from './../../../services/local-storage.service';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ApiResponseModel } from 'src/app/models/shared-model';
import { catchError, forkJoin, Observable, tap, throwError, Subscription, map, timeInterval, finalize } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductsService } from 'src/app/services/products.service';
import { HttpClient } from '@angular/common/http';
import { ProductFileViewerComponent } from '../product-settings/product-file-viewer/product-file-viewer.component';
import { MatDialog } from '@angular/material/dialog';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Swal from 'sweetalert2';
import { ProductDistributionRequestComponent } from '../product-distribution-request/product-distribution-request.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-product-page',
  templateUrl: './product-page.component.html',
  styleUrls: ['./product-page.component.scss'],
})

export class ProductPageComponent implements OnInit {
  @Output() closeToBack = new EventEmitter<any>();
  @Input() selectedViewData:any;

  productDetails$!: Observable<ApiResponseModel<any> | null>;
  catalogFiles: any[] = [];
  descriptionContent : string = '';
  triggerMSG: boolean = false;
  selectedMainImage : any;
  zoomStyle = {};
  rating: number = 4;
  stars: number[] = [1, 2, 3, 4, 5];
  tabSliderPosition = 0; 
  tabSliderWidth = 0;
  selectedFile: string = '';
  selectedFileType: string = '';
  activeTab = 0;
  previousTab: number = 0;
  animateContent: boolean = false;
  data: any;
  oemData: any;
  breadcrumb: any;
  currImg: number = 0;
  autoSlideInterval: any;
  moreImages: any = false;
  userDetails: any;
  currDate: string = '';
  currTime: string = '';
  signin: any;
  id: any;
  products: any[] = [];
  specifications: any[] = [];
  starIndex = -1;
  toggleWriteReview: boolean = false;
  ratingCount: any[] = [0, 0, 0, 0, 0]
  isEditReview: boolean = false;
  editReviewData: any;
  reviews: any[] = [];
  review: string = '';
  myReviews: any[] = [];
  totalReviews: number = 0;
  roleName: string = '';
  isLoggedIn:boolean = false;
  displayReviews: number = 5;
  reviewsBatchSize: number = 5;
  userId!: string;
  averageRating: any;
  totalCards: number = 10;
  currentPage: number = 1;
  pagePosition: string = "0%";
  cardsPerPage: any;
  totalPages: any;
  overflowWidth: string | undefined;
  cardWidth: string | undefined;
  containerWidth?: number;
  videoMoved: boolean = false;
  currVideo: string = '';  
  @ViewChild("container", { static: true, read: ElementRef })
  container: any; 
  media: string[] = [];
  isVideo: boolean = false;
  reviewForm!: FormGroup;
  isViewAll: boolean = false;
  reviewExists: boolean = false;
  loopActive: boolean = true;
  isVideoPlaying: boolean = false;
  isPlayingVideo: boolean = false;
  showSimilarProductsNumber: number = 5;
  remainingChars: number = 512;

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    translate: 'yes',
    enableToolbar: true,
    showToolbar: false,
    placeholder: 'Write your review here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private productService: ProductsService,
    private http: HttpClient,
    private dialog: MatDialog,
    private allProductService : AllProductService,
    private categoryService: CategoryService,
    private localStorageService: LocalStorageService,
    private changeDetectorRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private spinnerService: SpinnerService,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService
  ) {
    this.localStorageService.getUserDetails().subscribe((userDetails) => {
      this.userId = userDetails?.userId;
      this.isLoggedIn = !!this.userId;
      this.signin = userDetails;
      this.userDetails = userDetails?.userName || '';      
    });
    this.roleName = this.localStorageService.getItem('roleName');
  }
  
  ngOnInit(): void {
    const topOfPage = document.querySelector('app-root');
    if (topOfPage) {
        topOfPage.scrollIntoView({ behavior: 'smooth' });
      } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    window.scroll(0, 0);
    this.ShowItemsBasedonScreenSize();
    this.startAutoSlide();
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      if (this.id) {
        this.getProductDetails(this.id)
      } 
    });
    this.selectedMainImage = this.selectedViewData?.images[0] 
    this.incrementViewCount(this.id);
    window.scroll(0, 0);
    this.reviewForm = this.fb.group({
      review: new FormControl('', [Validators.required])
    });
    this.isViewAll = window.history.state.isViewAll;
    this.reviewForm.get('review')?.valueChanges.subscribe((value: string) => {
      const totalLength = value ? value.length : 0; 
      this.remainingChars = 512 - totalLength;

      if (totalLength > 512) {  
        this.ratingError[1] = true;  
      } else {
        this.ratingError[1] = false;
      }

      if (totalLength === 0) {
        this.ratingError[2] = true; 
      } else {
        this.ratingError[2] = false;
      }
    });
  }

  incrementViewCount(id: any) {
   this.productService.increamentProductCount(id).subscribe((res: any) => {
   })
  }

  productClicked(product: any){
    const topOfPage = document.querySelector('app-root');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
  onLoginPage() {
    this.router.navigate(['/login']);
  }
  ngAfterViewInit() {
    if(this.authService.isAuthenticated() === false){
      this.isLoggedIn = false;
      this.signin = null;
    }  
  }
  ratingError: any = [false, false, false];
  
  writeReview(reviewData: any) {
    this.spinnerService.showSpinner();
    const totalLength = reviewData.description.length; 
    this.reviewForm.get('review')?.reset();
    this.remainingChars = 512; 

    if (reviewData.rating < 1) {
        this.ratingError[0] = true;
        this.spinnerService.hideSpinner();
        return;
    } else {
        this.ratingError[0] = false;
    }

    if (totalLength > 512) {  
        this.ratingError[1] = true;
    } else {
        this.ratingError[1] = false;
    }

    if (totalLength === 0) {
        this.ratingError[2] = true;
    } else {
        this.ratingError[2] = false;
    }

    if (this.ratingError.includes(true)) {
        this.spinnerService.hideSpinner();
        return;
    }   

    this.productService.postReview(reviewData).subscribe((res: any) => {
        this.getReviews(this.id);
        this.changeDetectorRef.detectChanges();
        this.starIndex = -1;
        this.review = '';
        this.toggleWriteReview = false;
        this.reviewForm.get('review')?.reset();
        this.spinnerService.hideSpinner();
    });
}

  calculatePercentage(rating: number): number {
    return Math.round((rating * 100) / this.totalReviews);
  }
  
  calculateDaysAgo(reviewDate: string): string {
    const reviewDateObj = new Date(reviewDate);
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - reviewDateObj.getTime();
    const dayDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
    if (dayDifference <= 0) {
        return 'Today';
    } else if (dayDifference === 1) {
        return 'Yesterday';
    } else if (dayDifference < 30) {
        return `${dayDifference} days ago`;
    } else if (dayDifference < 60) {
        return 'a month ago';
    } else if (dayDifference < 365) {
        const months = Math.floor(dayDifference / 30);
        return `${months} month${months > 1 ? 's' : ''} ago`;
    } else if (dayDifference < 730) {
        return 'a year ago';
    } else {
        const years = Math.floor(dayDifference / 365);
        return `${years} year${years > 1 ? 's' : ''} ago`;
    }
}  

getReviews(id: any) {  
  this.totalReviews = 0;
  this.ratingCount = [0, 0, 0, 0, 0];
  this.productService.getProductReviews(id, 0, 100).subscribe((res: any) => {
    if (res && res.data && res.data.reviews) {      
      this.reviews = res.data.reviews.map((t: any) => {
        if(t.userId == this.userId) { 
          this.reviewExists = true;
         }        
        t.date = String(new Date(t.date));
        this.ratingCount[5 - t.rating]++;
        return t;
      });
      this.totalReviews = this.reviews.length;
      this.averageRating = res.data.averageRating;
      this.reviews = this.reviews;
    }
  });
}

editReview(reviewId: string) {
  this.toggleWriteReview = true;
  this.isEditReview = true;
  this.editReviewData = this.reviews.find((t: any) => t.reviewId === reviewId);

  const writeReviewElement = document.querySelector('.writeAReview button');
  if (writeReviewElement) {
    writeReviewElement.scrollIntoView({behavior: 'smooth'});
  }
  
  if (this.editReviewData) {
    this.starIndex = this.editReviewData.rating;
    this.reviewForm.get('review')?.setValue(this.editReviewData.description);
  }
}

  putReview(data: any, id: string){
    this.spinnerService.showSpinner();
    this.productService.editProductReview(data, id).subscribe((res: any)=>{
      this.getReviews(this.id);
      this.starIndex = -1;
      this.review = '';
      this.toggleWriteReview = false;
      this.changeDetectorRef.detectChanges();
      this.reviewForm.get('review')?.reset();
      this.spinnerService.hideSpinner();
    })
  }
  
  addReview(type: string) {
    if (type === 'cancel') {
      this.starIndex = -1;
      this.reviewForm.get('review')?.reset();
      this.toggleWriteReview = false;
      this.ratingError[2] = false;
      this.ratingError[0] = false;
      this.remainingChars = 512; 
    }

    if (type === 'add') {
      
      const reviewData = {
        productId: this.data.id,
        description: this.reviewForm.get('review')?.value || '',  
        rating: this.starIndex,
        userId: this.userId
      };

      if (this.starIndex < 1) { 
        this.ratingError[0] = true;
        if(reviewData.description.length === 0) {
          this.ratingError[2] = true;
        }
        return;
      }
      else {
        this.ratingError[0] = false;
      }

      if (reviewData.description.length > 512 || reviewData.description.length === 0) {
        if (reviewData.description.length > 512) {
          this.ratingError[1] = true;
        }
        else {
          this.ratingError[2] = true;
        }
        return;
      }
      this.ratingError[1] = false;
      
  
      if (this.isEditReview) {
        this.putReview(reviewData, this.editReviewData.reviewId);
        this.isEditReview = false;
      } else {
        this.writeReview(reviewData);
      }
  
      this.reviewForm.get('review')?.reset();
      this.starIndex = -1;
    } else {
      this.starIndex = -1;
      this.reviewForm.get('review')?.reset();
      this.toggleWriteReview = false;
      this.ratingError[2] = false;
      this.ratingError[0] = false;
    }
  }
  
  reviewInput(){
    this.toggleWriteReview = true;
  }

  deleteReview(reviewId: string) {
    this.reviews = this.reviews.filter((review: any) => review.id !== reviewId);
    this.reviewForm.get('review')?.setValue('');
    this.starIndex = -1;
    this.totalReviews = this.reviews.length;
    this.toggleWriteReview = false;
    this.reviewForm.get('review')?.reset();
    this.starClicked(0)
    this.isEditReview = false;
    
    this.productService.deleteProductReview(reviewId).subscribe(
      (res: any) => {
        this.reviewExists = false;
        this.getReviews(this.id);
        this.changeDetectorRef.detectChanges();
        Swal.fire({
          icon: 'success',
          title: 'Review Deleted Succesfully',
        })
      },
      (error: any) => {
        this.getReviews(this.id); 
      }
    );
  }

  getBreadcrumb(categoryId: string) {
    if(categoryId) {
      this.categoryService.getBreadcrumb(categoryId).subscribe((res: any ) => {
        this.breadcrumb = res;  
        this.breadcrumb.push({
          id: this.data.id,
          name: this.data.name,
          isProduct: true
        })
      })
    }
  }

  applyForDistributor(){    
    if(this.roleName === 'DISTRIBUTOR'){
      this.router.navigate(['productDistributionRequest', this.id])
    }
    else{
      Swal.fire({
        title: "We're sorry, but it seems like you are currently unable to send a Partner or Distributor request to the OEM.",
        text: 'However, you can still apply for distribution rights by creating a Distributor account. Click the button below to sign up for a new account and start the process today',
        iconHtml: '<img src="./assets/images/group-delete.svg">',
        iconColor : 'white',
        showCancelButton: true,
        confirmButtonText: 'Sign up for Distributor',
        confirmButtonColor : 'rgba(13, 135, 200, 1)',
        cancelButtonText: 'Close',
        cancelButtonColor : 'rgba(173, 173, 173, 1)'  
      }).then((t: any)=>{
        if(t.isConfirmed) {
          this.router.navigate(['/distributor/signup']);
        }
      })
    }
  }

  getProductDetails(id: string) {
    this.productDetails$ = this.productService.getProductDetails(id);
    this.productDetails$.subscribe((res: any) => {
      this.data = res?.data?.productInfoDTO || {};
      this.media = this.data.images;
      this.isVideo = false;
      this.currImg = 0;
      if(this.data?.video){
        this.isVideo = true;
        this.media = [...this.media, this.data.video];
      }
      this.oemData = res.data;
      (this.media && this.media.length>4)?(this.moreImages = true): (this.moreImages = false);
      this.catalogFiles = [];
      this.processCatalogs(this.data.catalogs);
      this.getBreadcrumb(this.data?.categoryId);
      this.getReviews(this.id)   
      this.getAllProducts(id, this.data?.categoryId);
    });
  }
  

  processCatalogs(urls: string[]): void {
    if (!urls || urls.length === 0) {
      return;
    }
    urls.forEach(url => {
      if (url) {
        this.fetchCatalogsDetails(url);
      }
    });
  }

  fetchCatalogsDetails(url: string): void {
    const fileName = this.extractFileName(url);
    const fileNameWithoutExtension = fileName.split('.').slice(0, -1).join('.');
    const fileExtension = url.split('.').pop(); 
    const definedExtensions = ['jpeg', 'png', 'jpg']; 
    const fileType = definedExtensions.includes(fileExtension as string) ? 'image' : 'pdf'; 
    const file = {
      name: fileName,
      size: Math.floor(Math.random() * 1024 * 1024), 
      url: url,
      progress: Math.floor(Math.random() * 100),
      type: fileType
    };
    this.catalogFiles.push({
      file: file,
      name: file.name,
      size: (file.size / 1024).toFixed(2), 
      url: file.url,
      type: fileType,
      fileViewName : fileNameWithoutExtension,
      progress: file.progress
    });
   
  }

  extractFileName(url: string): string {
    return url.substring(url.lastIndexOf('/') + 1);
  }

  back(){
    this.closeToBack.emit(true);
  }

  setMainImage(image: any) {
    this.selectedMainImage = image;
  }

  zoomIn() {
    this.zoomStyle = {
      transform: 'scale(1.2)',
      transition: 'transform 0.2s ease-in-out'
    };
  }

  zoomOut() {
    this.zoomStyle = {
      transform: 'scale(1)',
      transition: 'transform 0.2s ease-in-out'
    };
  }

  setTabSliderWidth() {
    const tabs = document.querySelectorAll('.tab');
    if (tabs.length > 0) {
      this.tabSliderWidth = (tabs[0] as HTMLElement).offsetWidth;
    }
  }

  setTabSliderPosition() {
    this.tabSliderPosition = this.activeTab * this.tabSliderWidth;
  }

  selectTab(index: number) {
    if (index !== this.activeTab) {
      this.previousTab = this.activeTab;
      this.activeTab = index;
      this.setTabSliderPosition();
    }
  }

  getAllProducts(currentProductId : string, categoryId: string) {
    if(categoryId) {
        this.productService.getAllProductsByCategory(categoryId, 0, 10).subscribe((res: any)=> {
          if(res?.data.length < 5) {
            this.getLatestProducts(res?.data, currentProductId) ;
          } else {
            this.products = res.data;
            this.products = this.products?.map((product: any) => ({
              id: product?.id,
              images: product?.images ,
              productname: product?.name,
              oemlogo: product?.logo,
              description: product?.description,
              specifications: product?.specifications,
              oemid: product?.oemId
            }));
          if(currentProductId){
            this.products = this.products?.filter((product: any) => product.id !== currentProductId);
          }
  
        this.products?.forEach((product: any) => {
          product.specifications?.forEach((spec: any) => {
            if (spec.isRange === 'false') {
              this.specifications.push(`${spec.fromValue} ${spec.fromUnit}`);
             
            } else {
              this.specifications.push(`${spec.fromValue} ${spec.fromUnit} - ${spec.toValue} ${spec.fromUnit}`);
            }
          });
        });
        this.specifications = this.specifications.slice(0, 3);
        }
      });
    }
  } 
  getLatestProducts(overallData: any, currentProductId: any) {
    this.productService.getTopProducts('LatestProducts').subscribe((res: any)=>{
        this.products = [...overallData, ...res?.data];
        this.products = this.products.map((product: any) => ({
          id: product?.id,
          images: product?.images ,
          productname: product?.name || product?.productname,
          oemlogo: product?.logo || product?.oemlogo,
          description: product?.description,
          specifications: product?.specifications,
          oemId: product?.oemid
        }));
        if(currentProductId){
          this.products = this.products.filter((product: any) => product.id !== currentProductId);
        }
        this.products.forEach((product: any) => {
        product.specifications.forEach((spec: any) => {
          if (spec.isRange === 'false') {
            this.specifications.push(`${spec.fromValue} ${spec.fromUnit}`);
           
          } else {
            this.specifications.push(`${spec.fromValue} ${spec.fromUnit} - ${spec.toValue} ${spec.fromUnit}`);
          }
        });
      });
      this.specifications = this.specifications.slice(0, 3);
    })
  }
  getEmbedUrl(videoUrl: string): string {
    const videoId = this.extractVideoId(videoUrl);
    return `https://www.youtube.com/embed/${videoId}`;
  }

  private extractVideoId(url: string): string {
    const videoIdMatch = url.match(/[?&]v=([^&]+)/);
    return videoIdMatch ? videoIdMatch[1] : '';
  }

  initializeSlider() {
    this.totalPages = Math.ceil(this.totalCards / this.cardsPerPage);
    this.overflowWidth = `calc(${this.totalPages * 100}% + ${this.totalPages *
      10}px)`;
    this.cardWidth = `calc((${100 / this.totalPages}% - ${this.cardsPerPage *
      10}px) / ${this.cardsPerPage})`;
  }

  changePage(incrementor: any) {
    this.currentPage += incrementor;
    this.populatePagePosition();
  }

  populatePagePosition() {
    this.pagePosition = `calc(${-100 * (this.currentPage - 1)}% - ${10 *
      (this.currentPage - 1)}px)`;
  }

  startAutoSlide() {
    this.clearAutoSlide(); 
    this.autoSlideInterval = setInterval(() => {
      if (this.loopActive) {
        this.btnNxt(false);
      }
    }, 4000);
  }
  clearAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }

 
  btnNext() {
    this.clearAutoSlide(); 
    if (this.currImg >= this.media.length - 1) {
      this.currImg = 0; 
    } else {
      this.currImg += 1;
    }
  }
  
  btnPrev() {
    this.clearAutoSlide(); 
    if (this.currImg <= 0) {
      this.currImg = this.media.length - 1;
    } else {
      this.currImg -= 1;
    }
  }
  
 
  btnNxt(type: boolean) {
    if (this.media && this.currImg === this.media.length - 1) {
      this.currImg = -1;
    }
    this.currImg += 1;
  }

  isVideoUrl(item: string): boolean {
    return item.includes('youtube') || item.includes('youtu.be') || item.includes('video');
  }
  smallImgs(idx: any){
    this.currImg = idx;
  }
  smallImgs1(idx: any){
    this.clearAutoSlide();
   this.currImg = idx;
 }
 playVideo1() {
  this.isPlayingVideo = true; 
  this.stopAutoScroll(); 
}
 stopAutoScroll() {
  this.loopActive = false; 
  clearInterval(this.autoSlideInterval);
}

  playVideo(){
    this.currImg = -10;
  }

  getInitials(name: string): string {
    return name.split(' ').map(n => n[0]).join('');
  }

  starClicked(i: number){
    this.ratingError[0] = false;

    if(this.starIndex===i){
      this.starIndex = -1
    }
    else{
      this.starIndex = i;
    }
  }

  sendEnquiry(){
    if(this.roleName === 'SUPER_ADMIN'){
      Swal.fire({
        title: 'Enquiry Restricted!!',
        text: "Super Admin don't have access to Send Enquiry!!",
        icon: 'error',
        confirmButtonText: 'Ok',
        confirmButtonColor : '#0f74a9',
        allowOutsideClick: false
      })
      return;
    }
    const oemId= localStorage.getItem('oemId');
    if (oemId && oemId === this.data.oemId) {
      Swal.fire({
        title: 'Invalid Action!',
        text: "Enquiries cannot be made on your own product.",
        icon: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#0f74a9',
        allowOutsideClick: false
      });
      return;
    }

     if(this.userId===null || this.userId=== ""|| this.userId===undefined){
      Swal.fire({
        iconHtml: '<img src="./assets/images/signin-icon.svg" height="90px" width="90px">',
        iconColor: '#ffffff',
        title: '<strong>Please log in to send an Product Enquiry</strong>',
        showCancelButton: true,
        confirmButtonText: 'Login',
        cancelButtonText: 'Cancel',
        html: `<p style="font-size: 13px; margin: 0px;"> Don't have an account? <a href="/user/signup" style="color: blue;font-size: 16px;font-weight: 600; text-decoration: underline;text-wrap:nowrap">Join Now</a></p>`,
        focusConfirm: false
      }).then((result) => {
                    if (result.isConfirmed) {
                      this.router.navigate(['/login']);
                    }
                  });
    }else{
      this.router.navigate(['/user/products/enquiry/', this.data.id])
    }
  }

  getFileType(url: string): string {
    const extension = url.split('.').pop();
    switch (extension) {
      case 'pdf':
        return 'pdf';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'image';
      default:
        return 'unknown';
    }
  }

  viewCatalog(catalog: any) {
    window.open(catalog.url, '_blank');
  }

  downloadCatalog(file: any) {
    const name = (file?.name) ? (file.name.toLowerCase()) : (file?.productName.toLowerCase());
    const url = (file.url) ? (file.url) : (file.catalog);
    this.allProductService.downloadFile(url, name).subscribe((blob: Blob) => {
      this.allProductService.saveFile(blob, name);
    }, error => {
     
    });
  }
  
  viewMoreReviews(){
    this.displayReviews += this.reviewsBatchSize;
  }

  ShowItemsBasedonScreenSize() {
    this.breakpointObserver.observe([
      '(min-width: 1190px) and (max-width: 1390px)'
    ]).subscribe(result => {
      if (result.matches) {
        if (result.breakpoints['(min-width: 1190px) and (max-width: 1390px)']) {
          this.showSimilarProductsNumber = 4;
        }
      } else {
        this.showSimilarProductsNumber = 5;
      }
    });
  }

  getProcessedVideoUrl(url: string): string {
    if (!url) return '';
  
    const youtubePattern = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//i;
    if (youtubePattern.test(url)) {
      const regExp = /(?:youtube\.com\/(?:.*[?&]v=|embed\/)|youtu\.be\/)([^&#?/]+)/;
      const match = url.match(regExp);
      const videoId = match ? match[1] : '';
      return videoId
        ? `https://www.youtube.com/embed/${videoId}?autoplay=0&controls=1`
        : '';
    }
  
    return url;
  }
  
}